<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-claims-claim-entitlement-setting-dialog-create
          v-if="$hasPermissionTo(['create claim entitlement settings'])" 
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Claim Entitlement Setting's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Type keyword here"
          append-icon="search"
          label="Search Claim Entitlement Setting"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredClaimEntitlementSettings"
      :single-expand="true"
      show-expand
      :search="search"
      :loading="tableLoading"
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border':'border-bottom'">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded)"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <span class="font-weight-bold">
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <span class="font-weight-bold">
              {{ ((props.item||{}).claim_type ||{}).name || 'N/A' }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <span class="font-weight-bold">
              {{ props.item.credit_unit }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <div class="text-center">
              <span v-if="props.item.credit_unit === 'day'">
                <v-icon
                  v-if="props.item.includes_end_date"
                  color="hrissecondary"
                >
                  mdi-check-outline
                </v-icon>
                <v-icon
                  v-else
                  color="error"
                >
                  mdi-close-outline
                </v-icon>
              </span>
              <span v-else>-</span>
            </div>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <div class="text-center">
              <span v-if="props.item.credit_unit === 'day'">
                <v-icon
                  v-if="props.item.allow_claim_half_entitlement"
                  color="hrissecondary"
                >
                  mdi-check-outline
                </v-icon>
                <v-icon
                  v-else
                  color="error"
                >
                  mdi-close-outline
                </v-icon>
              </span>
              <span v-else>-</span>
            </div>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <div class="text-center">
              <span v-if="props.item.credit_unit === 'day'">
                <v-icon
                  v-if="props.item.allow_combine_entitlement"
                  color="hrissecondary"
                >
                  mdi-check-outline
                </v-icon>
                <v-icon
                  v-else
                  color="error"
                >
                  mdi-close-outline
                </v-icon>
              </span>
              <span v-else>-</span>
            </div>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
            <span v-if="statusFilter">
              <span class="mx-1" />
              <setup-claims-claim-entitlement-setting-dialog-edit
                v-if="$hasPermissionTo(['update claim entitlement settings'])"
                :setting="props.item"
                @updated="loadData(); $emit('updated')"
              />
              <setup-claims-claim-entitlement-setting-dialog-delete
                v-if="$hasPermissionTo(['delete claim entitlement settings'])"
                :setting="props.item"
                @deleted="loadData(); $emit('updated')"
              />
            </span>
            <span v-else>
              <setup-claims-claim-entitlement-setting-dialog-restore
                v-if="$hasPermissionTo(['restore claim entitlement settings'])"
                :setting="props.item"
                @restored="loadData"
              />
            </span>
          </td>
        </tr>
      </template>
            
      <template v-slot:expanded-item="{ headers, item }">   
        <td
          class="details pb-3"
          :colspan="12"
        >
          <setup-claims-claim-entitlement-setting-detail-dialog-create
            v-if="$hasPermissionTo(['create claim entitlement settings'])"
            :claim-entitlement-setting="item"
            :job-categories="jobCategories"
            :credit-unit="item.credit_unit"
            @created="loadData"
          />
          <v-data-table
            hide-default-footer
            style="border:1px solid #e6e6e6"
            dense
            class="mt-2"
            :items="item.claim_entitlement_setting_details.map(d => ({ ...d, credit_unit: item.credit_unit }))"
            :headers="settingHeaders"
            :loading="settingTableLoading"
          >
            <template v-slot:item.max_amount="{ item }">
              <span>RM {{ currencyFormatting(item.max_amount) }} / {{ item.credit_unit }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <setup-claims-claim-entitlement-setting-detail-dialog-edit
                v-if="$hasPermissionTo(['update claim entitlement settings']) && statusFilter"
                :claim-entitlement-setting-detail="item"
                :job-categories="jobCategories"
                :credit-unit="item.credit_unit"
                @updated="loadData"
              />
              <setup-claims-claim-entitlement-setting-detail-dialog-delete
                v-if="$hasPermissionTo(['delete claim entitlement settings']) && statusFilter"
                :claim-entitlement-setting-detail="item"
                @deleted="loadData"
              />
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimEntitlementSettingDialogCreate: () => import('@/components/hris/setup/claims/claim-entitlement-setting/DialogCreate'),
      SetupClaimsClaimEntitlementSettingDialogDelete: () => import('@/components/hris/setup/claims/claim-entitlement-setting/DialogDelete'),
      SetupClaimsClaimEntitlementSettingDialogEdit: () => import('@/components/hris/setup/claims/claim-entitlement-setting/DialogEdit'),
      SetupClaimsClaimEntitlementSettingDialogRestore: () => import('@/components/hris/setup/claims/claim-entitlement-setting/DialogRestore'),
    
      SetupClaimsClaimEntitlementSettingDetailDialogCreate: () => import('@/components/hris/setup/claims/claim-entitlement-setting-detail/DialogCreate'),
      SetupClaimsClaimEntitlementSettingDetailDialogEdit: () => import('@/components/hris/setup/claims/claim-entitlement-setting-detail/DialogEdit'),
      SetupClaimsClaimEntitlementSettingDetailDialogDelete: () => import('@/components/hris/setup/claims/claim-entitlement-setting-detail/DialogDelete'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Claim Entitlement Settings',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Claim Type',
            align: 'left',
            value: 'claim_type.name',
          },
          {
            text: 'Credit Unit',
            align: 'left',
            value: 'credit_unit',
            width: '120px',
          },
          {
            text: 'Includes End Date?',
            align: 'center',
            value: 'includes_end_date',
            width: '130px',
          },
          {
            text: 'Allow Half Day Entitlement?',
            align: 'center',
            value: 'allow_claim_half_entitlement',
            width: '150px',
          },
          {
            text: 'Allow Combine Entitlement?',
            align: 'center',
            value: 'allow_combine_entitlement',
            width: '150px',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
            width: '120px',
          },
        ],
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        claimEntitlementSettings: [],
        trashedClaimEntitlementSettings: [],
        jobCategories: [],
        tableLoading: true,
        settingTableLoading: false,
        settingHeaders: [
          {
            text: 'Job Category',
            align: 'left',
            value: 'job_category.name',
            sortable: false,
          },
          {
            text: 'Maximum Amount',
            align: 'left',
            value: 'max_amount',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },
    computed: {
      filteredClaimEntitlementSettings () {
        return this.statusFilter ? this.claimEntitlementSettings : this.trashedClaimEntitlementSettings
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.claimEntitlementSettings().list(),
          this.$api.claimEntitlementSettings().listTrashed(),
          this.$api.jobCategories().list(),
        ]).then(([claimEntitlementSettings, trashedClaimEntitlementSettings, jobCategories]) => {
          this.claimEntitlementSettings = claimEntitlementSettings.data
          this.trashedClaimEntitlementSettings = trashedClaimEntitlementSettings.data
          this.jobCategories = jobCategories.data

          this.$emit('loaded')
          this.tableLoading = false
        })
      },
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style scoped>
.details {
  padding-left:85px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-right:85px;
}

.remove-bottom-border {
  border-bottom: 0px !important
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
